export const KEY_FIGURE_ALL = 'KEY_FIGUARE_ALL';
export const KEY_FIGURE_SINGLE = 'KEY_FIGURE_SINGLE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
